export default __webpack_public_path__ + "static/media/web-site.8141716b.svg";